import React from "react";
import { Modal, Switch } from "antd";
import LabeledInput from "../ui/LabeledInput";
import Dropdown from "../ui/Dropdown";

const AddBookModal = ({
  visible,
  onCancel,
  onSubmit,
  formData,
  setFormData,
  dropdownOptions,

  previewCover,
  previewBanner,
  onChangeCover,
  onChangeBanner,
}) => {
  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <Modal
      title={formData.id ? "Edit Book" : "Add New Book"}
      open={visible}
      onCancel={onCancel}
      onOk={onSubmit}
      okText={formData.id ? "Update" : "Submit"}
      width={700}
    >
      <div className="space-y-4">
        <LabeledInput
          label="Title"
          value={formData.title}
          onChange={(e) => handleChange("title", e.target.value)}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <LabeledInput
            label="Code"
            value={formData.code}
            onChange={(e) => handleChange("code", e.target.value)}
          />

          <LabeledInput
            label="Author"
            value={formData.author}
            onChange={(e) => handleChange("author", e.target.value)}
          />

          <Dropdown
            label="Language"
            options={dropdownOptions.languages}
            value={formData.language_id}
            onChange={(val) => handleChange("language_id", val)}
          />

          <Dropdown
            label="Category"
            options={dropdownOptions.categories}
            value={formData.category_id}
            onChange={(val) => handleChange("category_id", val)}
          />

          {/* ⭐ COVER IMAGE PREVIEW + FILE INPUT ⭐ */}
          <div>
            <label className="p-1">Cover Image</label>

            <div
              style={{
                width: 120,
                height: 80,
                border: "1px solid #ddd",
                borderRadius: 8,
                marginBottom: 8,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              {previewCover ? (
                <img
                  src={previewCover}
                  style={{ width: 120, height: 80, borderRadius: 6 }}
                />
              ) : (
                <div
                  style={{ width: 120, height: 80, background: "#f0f0f0" }}
                />
              )}
            </div>

            <input
              type="file"
              accept="image/*"
              onChange={(e) => onChangeCover(e.target.files[0])}
            />
          </div>

          {/* ⭐ BANNER IMAGE PREVIEW + FILE INPUT ⭐ */}
          <div>
            <label className="p-1">Banner Image</label>

            <div
              style={{
                width: 120,
                height: 80,
                border: "1px solid #ddd",
                borderRadius: 8,
                marginBottom: 8,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              {previewBanner ? (
                <img
                  src={previewBanner}
                  style={{ width: 120, height: 80, borderRadius: 6 }}
                />
              ) : (
                <div
                  style={{ width: 120, height: 80, background: "#f0f0f0" }}
                />
              )}
            </div>

            <input
              type="file"
              accept="image/*"
              onChange={(e) => onChangeBanner(e.target.files[0])}
            />
          </div>

          <Dropdown
            label="Status"
            options={[
              { value: "true", label: "Published" },
              { value: "false", label: "Draft" },
            ]}
            value={formData.is_active}
            onChange={(val) => handleChange("is_active", val)}
          />

          <Dropdown
            label="Mode"
            options={[
              { value: "Private", label: "Private" },
              { value: "Public", label: "Public" },
            ]}
            value={formData.mode}
            onChange={(val) => handleChange("mode", val)}
          />

          {/* <LabeledInput
            label="Last Applied Script Number"
            value={formData.lastScriptNumber}
            onChange={(e) => handleChange("lastScriptNumber", e.target.value)}
          /> */}

          <Dropdown
            label="State"
            options={dropdownOptions.states}
            value={formData.state_id}
            onChange={(val) => handleChange("state_id", val)}
          />

          <LabeledInput
            label="Description"
            value={formData.description}
            onChange={(e) => handleChange("description", e.target.value)}
          />

          {/* ⭐ NEW SWITCHES ⭐ */}
          <div className="flex items-center gap-3 mt-2">
            <label className="font-medium">Protected</label>
            <Switch
              checked={!!formData.is_protected}
              onChange={(checked) => handleChange("is_protected", checked)}
            />
          </div>

          <div className="flex items-center gap-3 mt-2">
            <label className="font-medium">Featured</label>
            <Switch
              checked={!!formData.is_featured}
              onChange={(checked) => handleChange("is_featured", checked)}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddBookModal;
